const configList = {
  // 区服查询
  ServerList: `/v1/RoleInfo/ServerList`,
};

export default (baseApi: string) => {
  const obj = {};
  for (const key of Object.keys(configList)) {
    obj[key] = `${baseApi}${configList[key]}`;
  }
  return obj;
};
